export class KafkaErrorHandlingConfig {
    'onError';
    'maxRetries';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "onError",
            "baseName": "onError",
            "type": "ErrorPolicy",
            "format": ""
        },
        {
            "name": "maxRetries",
            "baseName": "maxRetries",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaErrorHandlingConfig.attributeTypeMap;
    }
    constructor() {
    }
}
